module.exports = __webpack_public_path__ + "img/ConditionMonitoring.2c816919.svg";